<template>
  <v-card class="bodyText">
    <v-card-title class="bodyBold">
      {{ cardData.title }}
      <InfoIcon :info-data="infoText || infoDetails[infoTag]" />
    </v-card-title>
    <v-card-actions>
      <v-container class="containerView">
        <v-row
          style="height:40%;"
          class="rowView"
        >
          <v-col
            v-if="cardData.Value==null||cardData.Value==-1000||cardData.Value==undefined"
            :cols="12"
            class="centerAlign h1"
          >
            -
          </v-col>
          <v-col
            v-else
            :cols="12"
            class="centerAlign h1"
          >
            {{ cardData.Value }}
          </v-col>
        </v-row>

        <v-row
          v-resize="onResize"
          style="height:60%;"
          class="rowView"
        >
          <highcharts
            ref="chartContainer"
            style="width:100%;height:100%;"
            :options="cardData.chart"
          />
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>

import Highcharts from "highcharts";
import nodata from "highcharts/modules/no-data-to-display";
nodata(Highcharts);
import InfoIcon from "@/core/InfoIcon.vue";

import { mapState } from "vuex";

export default {
  name: "CardWChart",
  components: {
    InfoIcon
  },
  computed: {
    ...mapState("main", ["infoDetails"])
  },
  props: {
    cardData:Object,
    infoTag:String,
    infoText:String
  },
  data: function () {
    return {
    };
  },
  methods: {
    onResize () {
      setTimeout(()=>{
        this.$refs["chartContainer"].chart.reflow();
      }, 1500);
    },
  }
};
</script>
